/**
 * Centralized API configuration.
 *
 * All API base URLs should be derived from these constants rather than
 * scattering `import.meta.env.VITE_API_BASE_URL` with inconsistent
 * fallbacks across the codebase.
 *
 * The `VITE_API_BASE_URL` env var MUST be set in deployed environments
 * (development, founder-dev, staging, production). The localhost fallback
 * is only for local development.
 */

/** Full API base URL including `/api/` suffix (e.g., `https://…/api/`) */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/';

/** Server root without `/api/` suffix (e.g., `https://…`) — used for Twilio, messaging, etc. */
export const API_SERVER_URL: string =
  API_BASE_URL.replace(/\/api\/?$/, '');
